import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { SelectDatasourceModalComponent } from '../select-datasource-modal/select-datasource-modal.component';

@Component({
    selector: 'app-inbuilt-datasource',
    templateUrl: './inbuilt-datasource.component.html',
    styleUrl: './inbuilt-datasource.component.scss',
    imports: [MatIcon, AppModalComponent, SelectDatasourceModalComponent]
})
export class InbuiltDatasourceComponent {
  @Output() selectDataSource = new EventEmitter<any>();

  @ViewChild('selectDatasourceModal') private selectDatasourceModal: any;
  @ViewChild('dsBody') private dsBody: any;
  @Input() hasDataSource: boolean = false;
  @Input() reportNameFromQueryParams: string = '';

  open(): void {
    this.dsBody?.resetDatasets();
    this.selectDatasourceModal?.show();
    this.dsBody?.ensureDatasourceOptionsLoaded();
  }

  onModalApply(result: { payload: any; response?: any }): void {
    this.selectDatasourceModal?.hide();
    this.selectDataSource.emit(result.payload);
  }

  onModalCancelled(): void {
    this.selectDatasourceModal?.hide();
  }
}

